import React, { useState, useEffect } from 'react';
import { handleResponse } from '../../helpers/handleresponse';
import Select from 'react-select';

export const CountryList = (props) => {
    const [countryList, setCountries] = useState([]);
    /*     const [countries, setCountriesBase] = useState([]); */
    useEffect(() => {
        if (!countryList || countryList.length < 1) {
            getCountries();
        }
    }, []);
    const getCountries = () => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch(`./api/country/`, requestOptions)
            .then(handleResponse)
            .then(countries => {
                let countryList = [];
                /*  setCountriesBase(countries) */
                countryList.push({ value: 0, label: '' })
                countries.map(c => {
                    countryList.push({ value: c.countryId, label: props.languageCode === 'swe' || props.languageCode === undefined ? c.nameSwe : c.nameInt });
                });

                setCountries(countryList)
            });
    }

    const { onChange, isReadOnly, template, value, element, width } = props;
    return (
        <div className="responsive-input" style={{ width: width }}>
            <Select
                onChange={selectedOption => onChange(selectedOption, "props.text", element)}
                isDisabled={isReadOnly || false}
                options={
                    countryList
                }
                placeholder=""
                styles={{
                    control: styles => ({
                        ...styles,
                        borderColor:
                            (template !== undefined &&
                                template.content.input.borderColor) ||
                            "unset",
                        borderRadius:
                            (template !== undefined &&
                                template.content.input.borderRadius) ||
                            "unset",
                        fontFamily:
                            (template !== undefined &&
                                template.content.input.fontFamily) ||
                            "unset",
                        fontWeight:
                            (template !== undefined &&
                                template.content.input.fontWeight) ||
                            "unset",
                        margin:
                            (template !== undefined &&
                                template.content.input.margin) ||
                            "unset",
                        boxShadow:
                            (template !== undefined &&
                                template.content.input.boxShadow) ||
                            "unset",
                        fontSize:
                            (template !== undefined &&
                                template.content.input.fontSize) ||
                            "unset",
                        color:
                            (template !== undefined &&
                                template.content.input.color) ||
                            "unset",
                        backgroundColor:
                            (template !== undefined &&
                                template.content.input.backgroundColor) ||
                            "unset",
                        maxWidth: "100%"
                    }),
                    menu: styles => ({
                        ...styles,
                        maxWidth: "100%"
                    }),
                    input: styles => ({
                        ...styles,
                        color:
                            (template !== undefined &&
                                template.content.input.color) ||
                            "unset",
                        fontSize:
                            (template !== undefined &&
                                template.content.input.fontSize) ||
                            "unset",
                        fontFamily:
                            (template !== undefined &&
                                template.content.input.fontFamily) ||
                            "unset"
                    }),
                    singleValue: styles => ({
                        ...styles,
                        fontSize:
                            (template !== undefined &&
                                template.content.input.fontSize) ||
                            "unset",
                        fontFamily:
                            (template !== undefined &&
                                template.content.input.fontFamily) ||
                            "unset",
                        color:
                            (template !== undefined &&
                                template.content.input.color) ||
                            "unset",
                    }),
                    option: styles => ({
                        ...styles,
                        fontSize:
                            (template !== undefined &&
                                template.content.input.color) ||
                            "unset",
                        fontFamily:
                            (template !== undefined &&
                                template.content.input.fontFamily) ||
                            "unset"
                    }),
                    placeholder: styles => ({
                        ...styles,
                        fontSize:
                            (template !== undefined &&
                                template.content.input.color) ||
                            "unset",
                        fontFamily:
                            (template !== undefined &&
                                template.content.input.fontFamily) ||
                            "unset"
                    })
                }}
                value={countryList.find(t => { return t.value === value })}
            />
        </div>
    )
}